<template>
  <div class="banner">
    <h2 class="title">
      <img src="@/assets/images/attention-sign.svg" alt="attention icon" />
      <span>
        {{ $t("CONNECT_WITH") }} {{ bannerData.email }}
        {{ $t("GET_PERMISSION") }} {{ bannerData.permission }}
      </span>
    </h2>
    <div class="more-info tooltip-btn" :data-text="tooltipText">
      <img src="@/assets/images/team-panel/info.svg" class="info-icon" alt="" />
      <p class="text-more-info">{{ $t("MORE_INFO") }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'library-banner',
  computed: {
    bannerData () {
      return JSON.parse(localStorage.getItem('bannerData'))
    },
    tooltipText () {
      const tooltip = this.$t('MORE_INFO_TOOLTIP_1') + ' ' + this.bannerData.permission + this.$t('MORE_INFO_TOOLTIP_2') + ' ' + this.bannerData.email + this.$t('MORE_INFO_TOOLTIP_3') + ' ' + this.bannerData.email + '.'
      return tooltip
    }
  }
}
</script>

<style lang="scss" scoped>
  .banner{
    display: flex; justify-content: center; align-items: center;
    border-block: 1px solid #E89416; height: 65px; width: 100%; background-color: #FEF7E8; text-align: center;
    .title{font-size: 17px; font-weight: bold;}
    .text-more-info{font-size: 16px;}
    .info-icon{
      width: 18px; height: 18px; margin-inline-start: 20px; margin-inline-end: 5px;
    }
    .more-info{display: flex; align-items: center; margin-top: 10px;}
    .tooltip-btn{
      &:before{
        max-width: 400px; width: max-content; top: -10px; line-height: 1.3;
      }
      &:after{
        left: unset;
        .rtl &{inset-inline-end: 77px;}
        .ltr &{
          inset-inline-end: 70px;
        }
      }
    }
  }
</style>
